/* eslint-disable @typescript-eslint/no-misused-spread, @typescript-eslint/restrict-template-expressions */
import { flare } from "@flareapp/js";
import {
    createEndpointBuilder,
    createEtagMiddleware,
} from "@smakecloud/api-client-helper";
import { storeToRefs } from "pinia";
import { routeMiddleware } from "./middlewares/routeMiddleware";

export const publicEndpoint = createEndpointBuilder(
    {
        onValidationError: (error) => {
            void flare.report(error);
        },
    },
    [createEtagMiddleware("production-frontend-api"), routeMiddleware],
);

export const authedEndpoint = publicEndpoint.use(() => {
    const { isLoggedIn, payload, token } = storeToRefs(useAuthStore());

    const userId = computed(() => payload.value?.user_id);

    return {
        beforeRequest: (options) => ({
            ...options,
            headers: {
                ...options.headers,
                Authorization: `Bearer ${token.value}`,
            },
        }),
        enabled: isLoggedIn,
        key: [userId],
    };
});
